import ScrollTransition from './transitions/scroll-transition';
import FadeTransition from './transitions/fade-transition';
export default {
  fade: FadeTransition,
  scroll: ScrollTransition
};